
<template>
  <div class="addressField_content">
    <van-radio-group v-model="checked" @change="checkAddress">
      <div>
        <van-radio
          class="addressField_items"
          v-for="(item, index) in addressDisabledMetreList"
          :key="index"
          :name="item.Id"
          :label-disabled="!item.DisabledMetre"
          :disabled="!item.DisabledMetre"
          >{{ item.Name }}{{ item.Phone }} {{ item.DetailAddress }}</van-radio
        >

      </div>

        <div>
        <van-radio
          class="addressField_items"
          v-for="(item, index) in addressList"
          :key="index"
          :name="item.Id"
          :label-disabled="!item.DisabledMetre"
          :disabled="!item.DisabledMetre"
          >{{ item.Name }}{{ item.Phone }} {{ item.DetailAddress }}</van-radio
        >

      </div>

      <!-- <div
        class="addressField_items"
        v-for="(item) in addressDisabledMetreList"
        :key="item.Id"

      >
        <van-radio :name="item.Id" label-disabled
          >{{ item.Name }}{{ item.Phone }} {{ item.DetailAddress }}</van-radio
        >
      </div> -->
    </van-radio-group>
  </div>
</template>
<script>
import axios from "../commons/AxiosMethod.js"
import { showToast } from "vant"
export default {
  name: "header",
  data () {
    return {
      addressList: [], // 配送距离地址集合
      addressDisabledMetreList: [], // 超出配送距离地址集合
      checked: ""
    }
  },
  props: {
    AttributeGroup: {}
  },
  components: {},
  mounted () {
    this.GetAddress()
  },
  methods: {
    // 获取地址
    GetAddress (item) {
      axios.apiMethod(
        "/api/User/GetUserAddress",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.addressList = []
            this.addressDisabledMetreList = []
            result.Data.forEach((element) => {
              if (element.DisabledMetre) {
                this.addressList.push(element)
              } else {
                this.addressDisabledMetreList.push(element)
              }

              if (element.Default && element.DisabledMetre) {
                this.checked = element.Id
              }
            })
          } else {
            showToast(result.Msg)
          }
        },
        (e) => {}
      )
    },
    checkAddress (id) {
      this.$emit("update:modelValue", id)
    }
  }
}
</script>
<style  lang="scss"  scoped>
.addressField_content {
  z-index: 100023144432;
  padding: 5px 20px;
  .addressField_items {
    padding: 5px;
    width: calc(100% - 40px);
  }
}
</style>
